import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { type DynamicAction, Dynamic } from '@shared/registry/dynamic';

import type { FilterChipConfig } from './filter-chip.types';

@Component({
  selector: 'app-filter-chip',
  templateUrl: './filter-chip.html',
  imports: [Dynamic],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterChip {
  readonly config = input.required<FilterChipConfig>();
  readonly disabled = input<boolean>(false);

  readonly clickEvent = output<DynamicAction>();

  protected readonly hasLabel = computed(() => !!this.config().label);
  protected readonly hasIcon = computed(() => !!this.config().icon);

  protected readonly contentColor = computed(() => `var(--filterchip-${this.config().state}-color)`);

  protected readonly backgroundColor = computed(() => `var(--filterchip-${this.config().state}-background)`);

  protected readonly borderColor = computed(() => `var(--filterchip-${this.config().state}-border-color)`);

  protected readonly borderWidth = computed(() => `var(--filterchip-${this.config().state}-border-width)`);

  protected readonly textConfig = computed(() => ({
    text: this.config().label ?? '',
    size: 'sm' as const,
    fontWeight: 'bold' as const,
    color: this.contentColor(),
  }));

  protected onClick(): void {
    const action = this.config().action;
    if (action) {
      this.clickEvent.emit(action);
    }
  }
}
